/**
* @ngdoc directive
* @name Notifications
*
* @description
  Admin task notifications
*/

(function () {
  app.directive('notifications', ["PATH", "ADMIN_TIMEZONE", "notificationsService", "notificationsUiService", "localStorageService", "$window", "alertService", "activityTitleService", "notificationCommentParser", "apiService", "$q", "personService", function (
    PATH,
    ADMIN_TIMEZONE,
    notificationsService,
    notificationsUiService,
    localStorageService,
    $window,
    alertService,
    activityTitleService,
    notificationCommentParser,
    apiService,
    $q,
    personService
  ) {
    return {
      restrict: 'E',
      scope: true,
      templateUrl: PATH.components + 'notifications/template.html',
      link: function ($scope, elem) {
        var adminsList = localStorageService.get('adminsList');
        $scope.ui = notificationsUiService.state;
        $scope.notifications = notificationsService.state;
        $scope.filteredNotifications = false;
        $scope.filterTitle = 'Filter By Unread';
        $scope.toggleNotificationStatus =
          notificationsService.actions.toggleNotificationStatus;
        $scope.toggleNotificationsVisibility = function () {
          notificationsUiService.actions.toggleNotificationsVisibility();
        };
        $scope.hideNotifications = function () {
          notificationsUiService.actions.hideNotifications();
        };
        $scope.resetFilter = function () {
          $scope.filteredNotifications = true;
          $scope.filterTitle = 'Reset filter';
        };
        $scope.unResetFilter = function () {
          $scope.filteredNotifications = false;
          $scope.filterTitle = 'Filter By Unread';
        };

        $scope.handleNotificationCardClick = function (notificationId, taskId) {
          notificationsUiService.actions.hideNotifications();
          var promise = notificationsService.actions.markRead(notificationId);
          if (promise) {
            promise.then(function () {
              goToCard(taskId);
            });
          } else {
            goToCard(taskId);
          }
        };

        function goToCard(taskId) {
          var userInfo = localStorageService.get('userInfo');
          var url = '/taskmanagement#/tasks/' + taskId;
          if (userInfo.isSlidedInAdmin) {
            return personService.slideOut(userInfo, false, url);
          }
          $window.location.href = url;
        }

        $scope.calcUnreadNotifications = function () {
          return _.filter(notificationsService.state.data, function (notification) {
            return !notification.isRead;
          }).length;
        };

        $scope.formatDate = function (date) {
          return moment(date)
            .tz(ADMIN_TIMEZONE)
            .format('MMM DD HH:mm');
        };
        $scope.formatEventDescription = function (activity) {
          return activityTitleService.format(
            adminsList,
            activity
          ).join(' ');
        };
        $scope.parseComment = notificationCommentParser.parse;

        init();
        function init() {
          var interval;
          if (notificationsUiService.state.loading) {
            return;
          }
          var userInfo = localStorageService.get('userInfo');
          var userId = userInfo.adminId || userInfo.id;
          notificationsUiService.actions.setLoading(true);
          $scope.nextPageNotifications = function () {
            notificationsService.actions.nextPageNotifications(userId).then(function (response) {
              $scope.notifications.data = $scope.notifications.data.concat(response.data);
            });
          };
          $scope.markReadNotifications = function () {
            var markReadNotification = notificationsService.actions.markReadNotifications(userId);
            markReadNotification.then(function (response) {
              if (response.data) {
                notificationsService.actions.fetchData(userId).then(function () {
                  $scope.notifications = notificationsService.state;
                });
              }
            });
          };
          var promise1 = notificationsService
            .actions
            .fetchData(userId)
            .then(function () {}, function (err) {
              alertService.error(err && err[0] ? err[0].errorMessage : '');
            });

          var promise2 = adminsList || apiService.getSome('admins')
            .then(function (res) {
              adminsList = res.data;
              localStorageService.set('adminsList', adminsList);
            });
          $q.all([promise1, promise2]).then(function () {
            notificationsUiService.actions.setLoading(false);
          });


          var REFRESH_INTERVAL = 30000;
          if (interval) clearInterval(interval);
          interval = setInterval(function () {
            notificationsService.actions.pullLatest(userId);
          }, REFRESH_INTERVAL);
        }
      }
    };
  }]);
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/notifications/directive.js